<template>
  <button-block
      :btnClass='disabled ? "btn-secondary" : btnClass'
      :text='text'
      :textIcon="textIcon"
      :sm="sm"
      :disabled="disabled"
  />
</template>

<script>
import ButtonBlock from "./ButtonBlock";

export default {
  components: {ButtonBlock},
  data: function () {
    return {}
  },
  props: {
    btnClass: {
      type: String,
      default: 'btn-success',
    },
    text: {
      type: String,
      default: 'Создать',
    },
    textIcon: {
      type: String,
      default: 'fas fa-plus',
    },
    sm: Boolean,
    disabled: Boolean,
  },
  computed: {},
  mounted() {

  },
  methods: {}
}
</script>
